import { createContext, useContext, useEffect, useState } from "react";

const THEMES = {
  orange: { name: "Orange", primary: "#FF4F00", primaryHover: "#FF6B2B", glow: "rgba(255,79,0,0.5)" },
  green: { name: "Green", primary: "#39FF14", primaryHover: "#5fff45", glow: "rgba(57,255,20,0.5)" },
  red: { name: "Red", primary: "#FF003C", primaryHover: "#ff3366", glow: "rgba(255,0,60,0.5)" },
  blue: { name: "Blue", primary: "#00A6FF", primaryHover: "#33b8ff", glow: "rgba(0,166,255,0.5)" },
  purple: { name: "Purple", primary: "#BF40FF", primaryHover: "#cf66ff", glow: "rgba(191,64,255,0.5)" },
  cyan: { name: "Cyan", primary: "#00F0FF", primaryHover: "#33f3ff", glow: "rgba(0,240,255,0.5)" },
};

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("tf_theme") || "orange");

  useEffect(() => {
    const t = THEMES[theme] || THEMES.orange;
    const root = document.documentElement;
    root.style.setProperty("--tf-primary", t.primary);
    root.style.setProperty("--tf-primary-hover", t.primaryHover);
    root.style.setProperty("--tf-glow", t.glow);
    localStorage.setItem("tf_theme", theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
